import { render, staticRenderFns } from "./addriskdialog.vue?vue&type=template&id=5338a6cc&scoped=true"
import script from "./addriskdialog.vue?vue&type=script&lang=js"
export * from "./addriskdialog.vue?vue&type=script&lang=js"
import style0 from "./addriskdialog.vue?vue&type=style&index=0&id=5338a6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338a6cc",
  null
  
)

export default component.exports